import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal } from "./motion";

export default function Faq({ items, testPrefix = "faq" }) {
  return (
    <Reveal>
      <Accordion type="single" collapsible className="w-full">
        {items.map((item, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-lineblue">
            <AccordionTrigger
              data-testid={`${testPrefix}-accordion-trigger-${i + 1}`}
              className="text-left font-display font-bold text-navy text-base sm:text-lg hover:text-steel hover:no-underline py-5"
            >
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-mutedslate text-sm sm:text-base leading-relaxed pb-5">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  );
}
